// Effects
import { AuthEffects } from './auth.effects';
import { DashboardEffects } from './dashboard.effects';
import { ViewProfileEffects } from './view-profile.effects';
import { FormsEffects } from '@switch_software/ui-components';
import { ForcedPasswordChangeEffects } from '@store/effects/forced-password-change.effects';

export const AppEffects = [
  AuthEffects,
  DashboardEffects,
  ViewProfileEffects,
  FormsEffects,
  ForcedPasswordChangeEffects,
];
